export default [
  {
    version: 1,
    migration: (storage) => {
      const dashboardCache = storage.get('cache.dashboard');
      if (!dashboardCache) {
        return;
      }

      if (dashboardCache.currencyCode) {
        storage.set('currencyCode', dashboardCache.currencyCode);
      }

      if (dashboardCache.introShown) {
        storage.set('intro', true);
      }

      if (dashboardCache.termsAgreed) {
        storage.set('tos', true);
      }

      storage.set('cache.dashboard', null);
    },
  },
];



// WEBPACK FOOTER //
// ./src/migrations.js